import { render, staticRenderFns } from "./refund-info.vue?vue&type=template&id=561d9b24&scoped=true"
import script from "./refund-info.vue?vue&type=script&lang=js"
export * from "./refund-info.vue?vue&type=script&lang=js"
import style0 from "./refund-info.vue?vue&type=style&index=0&id=561d9b24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561d9b24",
  null
  
)

export default component.exports